import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { RedoConversionRpcClientContext } from "@redotech/redo-merchant-app-common/redo-conversion-rpc-client-provider";
import {
  ScheduleDemoButtonLocation,
  getScheduleDemoDestinationUrl,
} from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { ConversionSuiteStatusesContext } from "../../redo-suite/conversion-cloud";

/**
 * Returns whether a feature is locked for the current team and a click handler
 * that opens the schedule-a-call flow for the given surface. Used by sidebar
 * nav items and dashboard upsell cards in the intent-only state.
 *
 * Unlike useHandleScheduleDemo (welcome-page flow), this skips the
 * Redo-employee order-counts modal — locked clicks should always go straight
 * to HubSpot so the analytics signal is consistent across employee/customer.
 */
export function useConversionLockedAction(
  buttonLocation: ScheduleDemoButtonLocation,
) {
  const { accessLevel } = useRequiredContext(ConversionSuiteStatusesContext);
  const conversionRpcClient = useRequiredContext(
    RedoConversionRpcClientContext,
  );

  const locked = accessLevel === "intent-only";

  const onLockedClick = useHandler(async () => {
    const calendarUrl = getScheduleDemoDestinationUrl();
    await conversionRpcClient.sendScheduleDemoClickedNotification({
      source: buttonLocation,
      calendarUrl,
    });
    window.open(calendarUrl, "_blank");
  });

  return { locked, onLockedClick };
}
